/* global axios */
/* eslint-disable class-methods-use-this */

class ContactAutomationRulesAPI {
  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/contact_automation_rules`);
  }

  show(accountId, id) {
    return axios.get(`/api/v1/accounts/${accountId}/contact_automation_rules/${id}`);
  }

  create(accountId, payload) {
    return axios.post(`/api/v1/accounts/${accountId}/contact_automation_rules`, {
      contact_automation_rule: payload,
    });
  }

  update(accountId, id, payload) {
    return axios.patch(`/api/v1/accounts/${accountId}/contact_automation_rules/${id}`, {
      contact_automation_rule: payload,
    });
  }

  delete(accountId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/contact_automation_rules/${id}`);
  }
}

export default new ContactAutomationRulesAPI();
